<template>
    <v-container fluid id="home" class="fill-height">
    <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
        >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        <!-- <v-snackbar v-model="snackbar1" :timeout="4000" top color="red">
            <span>Oopss! An error occured. Try again later</span> 
            <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
        </v-snackbar> -->
        <v-snackbar v-model="snackbar2" top color="red">
            <span>Sorry, you are not authorised to make offer yet!!!</span> 
            <v-btn text color="white" @click="snackbar2 = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
            <!-- <span>Wish List Url Has Issues. Confirm you have prices attached to each items</span>  -->
            <span>{{message}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <h2 class="text-center ">Import Amazon Wish List.</h2>
                <v-card class="px-9 mx-auto mt-3" id="login" max-width="700px">
                
                    <v-card-text class="black--text">
                        <ol  class="">
                            <li class="pa-3">Visit Amazon and add items to Wish List.</li>
                            <li class="pa-3">Add shipping address to your Wish List.</li>
                            <li class="pa-3">Ensure the list is set to <b>Public.</b></li>
                            <li class="pa-3">Click <b>SEND LIST TO OTHERS.</b></li>
                            <li class="pa-3">Copy list link.</li>
                        </ol>
                        <v-form ref="form">
                            <v-text-field class="mt-3" outlined label="Paste Amazon Wish List Url" name="offer" v-model="offer" type="text" color="green" :rules="webRules"></v-text-field>

                        </v-form>
                        <div class="text-right mt-n12 mr-1 hidden-sm-and-down">
                            <v-btn small dark color="success" style="border-radius:15px" :loading="loading" class="heading mt-n11" @click="createoffer()">
                                Create Offer
                            </v-btn>
                        </div>
                        <div class="text-right mt-2 hidden-md-and-up">
                            <v-btn small dark color="success" style="border-radius:15px" :loading="loading" class="heading mt-n11" @click="createoffer()">
                                Create Offer
                            </v-btn>
                        </div>
                        
                    </v-card-text>
                    
                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>
<script>
export default {
    components:{
    },
    name:'SignUp',
    data(){
        return{
            loading:false,
            offer:"",
            snackbar:false,
            snackbar1:false,
            snackbar2:false,
            snackbarVerify:false,
            message:'',
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            webRules:[v => !!v || 'URL is required']
        }
    },
    methods:{
        createoffer(){
            const isUserLogged= this.$store.state.auth.isUserLogged
            const isUserVerified = this.$store.state.auth.logindetails.isVerified
            const canMakeOffer = this.$store.state.auth.logindetails.makeOfferAsShopper
            if(isUserLogged===true&&isUserVerified===1){
                if(canMakeOffer===true){
                    if (this.$refs.form.validate()){
                        this.loading = true
                        this.$store.dispatch("CreateOffer", {
                        "wishlistUrl": this.offer,
                        })
                        .then(()=>{
                            this.loading = false
                            this.$router.push('/setdiscount')

                        })
                        .catch((error)=>{
                            // console.log(error.response.data.message)
                            let msg = error.response.data.message
                            this.message=msg.toUpperCase()
                            this.snackbar = true
                            this.loading = false
                            // if(error.response.status===400){
                            //     this.snackbar = true
                            //     this.loading = false
                            // }else{
                            //     this.snackbar1 = true
                            //     this.loading = false
                            // }
                        });
                    }
                }else{
                    this.snackbar2 = true
                }
                
            }else{
                this.$router.push('/login')
            }
        }
        
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
        this.$store.dispatch("GetBtcRate")
        .then(()=>{
            
        })
        .catch((error)=>{
            console.log(error);
        })
    },
    computed:{
        BtcRate(){
            return this.$store.state.offer.BtcRate
        },
    }
    
}
</script>
<style  scoped>
    
    
    #login{
        border-radius: 5px;
    }
    .forgot{
        text-transform: capitalize;
    }
    li::before {
        padding-right: 8px;
        color: blue; /* Or a color you prefer */
    }

</style>